"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProfileGeneralTab = void 0;
const doNothing_1 = __importDefault(require("@opsbase/lib-general/utils/doNothing"));
const lib_i18n_1 = __importDefault(require("@opsbase/lib-i18n"));
const lib_self_1 = __importDefault(require("@opsbase/lib-self"));
const useSelf_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelf"));
const useSelfActions_1 = __importDefault(require("@opsbase/react-ctrl-self/useSelfActions"));
const useSelfUpdate_1 = __importDefault(require("@opsbase/react-gql-hooks/self/useSelfUpdate"));
const Horizontal_1 = __importDefault(require("@opsbase/web-layout/Horizontal"));
const Pane_1 = __importDefault(require("@opsbase/web-layout/Pane"));
const TextFieldWithStateAndBlur_1 = __importDefault(require("@opsbase/web-textfield/TextFieldWithStateAndBlur"));
const Avatar_1 = __importDefault(require("@opsbase/web-ui/Avatar"));
const react_1 = __importStar(require("react"));
function ProfileGeneralTab() {
    const [imageLoading, setImageLoading] = (0, react_1.useState)(false);
    const self = (0, useSelf_1.default)(true);
    const { setRealSelfOnly } = (0, useSelfActions_1.default)();
    const selfUpdate = (0, useSelfUpdate_1.default)();
    const handleSubmit = (0, react_1.useCallback)((title, hasProfileImage, profileImage) => {
        if (hasProfileImage && profileImage)
            setImageLoading(true);
        selfUpdate({
            title,
            hasProfileImage,
            profileImage,
        }, {
            context: {
                forceReal: true,
                hasUpload: !!profileImage, // activate Upload link
            },
        })
            .then(data => {
            setRealSelfOnly(lib_self_1.default.fromData(data));
            setImageLoading(false);
        })
            .catch(doNothing_1.default);
    }, [selfUpdate, setRealSelfOnly]);
    const handleRemoveImage = (0, react_1.useCallback)(() => {
        handleSubmit(undefined, false, null);
    }, [handleSubmit]);
    const handleChangeImage = (0, react_1.useCallback)(image => {
        handleSubmit(undefined, true, image);
    }, [handleSubmit]);
    const handleChangeName = (0, react_1.useCallback)(name => {
        handleSubmit(name, undefined, undefined);
    }, [handleSubmit]);
    if (!self) {
        return react_1.default.createElement("div", null, lib_i18n_1.default.t('loading'));
    }
    return (react_1.default.createElement(Horizontal_1.default, { centered: true, gutter: true },
        react_1.default.createElement(Pane_1.default, { grow: true },
            react_1.default.createElement(Avatar_1.default, { user: self, uploading: imageLoading, allowEdit: true, onImageRemove: handleRemoveImage, onImageChange: handleChangeImage })),
        react_1.default.createElement(Pane_1.default, { grow: true },
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { white: true, fullWidth: true, value: self.title, onBlur: handleChangeName }),
            react_1.default.createElement(TextFieldWithStateAndBlur_1.default, { white: true, fullWidth: true, disabled: true, value: self.email }))));
}
exports.ProfileGeneralTab = ProfileGeneralTab;
exports.default = ProfileGeneralTab;
